import { render, staticRenderFns } from "./MainVideo.vue?vue&type=template&id=6a8c1b4c&"
import script from "./MainVideo.vue?vue&type=script&lang=js&"
export * from "./MainVideo.vue?vue&type=script&lang=js&"
import style0 from "./MainVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports